import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { IconButton, Text, Popover } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../../i18n/messages';
import { UnifiedTheme } from '../../../FeatureApp';

const Container = styled.div`
  position: relative;
  margin: 0 0 0 8px;
  #popover-raiting-disclaimer {
    min-width: 191px;
    max-width: 191px;
  }
`;

const Content = styled.div`
  min-width: 191px;
  background: ${(props: UnifiedTheme) =>
    process.env.IS_LEGACY ? props.theme.sys.color.canvas.default : 'transparent'};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  row-gap: 20px;
`;

const ButtonStyled = styled(IconButton)`
  padding: 0;
  min-width: 25px;
  width: 25px;
`;

export const RatingDisclaimer = () => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const ref = useRef<HTMLDivElement | null>(null);
  const contentRef = useRef(null);

  const handleButtonClick = (event: any) => {
    if (event.target !== buttonRef?.current || event.target !== contentRef?.current) {
      setOpen(false);
    }
    setOpen(!open);
  };

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref?.current && !ref?.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const textParagraphs = useI18n(messages.five_star_rating_tooltip)?.split(/[\r\n]+|(?<=\.)/);
  return (
    <Container ref={ref}>
      {ref && ref.current && (
        <Popover
          content={
            <Content ref={contentRef}>
              {textParagraphs.map((line, index) => (
                // eslint-disable-next-line
                <Text key={index}>{line}</Text>
              ))}
            </Content>
          }
          id="popover-raiting-disclaimer"
          triggerElement={
            <ButtonStyled
              onClick={handleButtonClick}
              variant="tertiary"
              icon="info-circle"
              size={'xs' as any}
              ref={buttonRef}
            />
          }
          open={open}
          onClose={() => {}}
          withTip
          documentAnchor={ref.current}
        />
      )}
    </Container>
  );
};
